import styled from "styled-components";
import color from "../../resource/color";

interface TableContainerProps {
  headerFontFamily?: string;
  bodyFontFamily?: string;
}

const TableContainer = styled.div<TableContainerProps>`
  font-family: ${(props) => props.bodyFontFamily || "IBM Plex Sans Thai"};
  border: 1px solid ${color["background2"]};
  border-bottom: none;
  border-radius: 8px;
  overflow: hidden;

  .ant-table-thead > tr > th {
    background: ${color["secondary"]};
    color: white;
    font-weight: 700;
    font-family: ${(props) => props.headerFontFamily || "IBM Plex Sans Thai"};
  }

  .ant-table-tbody > tr > td {
    font-family: ${(props) => props.bodyFontFamily || "IBM Plex Sans Thai"};
  }

  .table-row-highlight {
    background-color: ${color["secondary"]}10;
  }

  .table-row-highlight:hover td {
    background-color: ${color["secondary"]}20 !important;
  }

  .table-row-clickable {
    cursor: pointer;
  }

  .ant-table-cell::before {
    content: none !important;
  }
`;

export default TableContainer;
